var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "widget projecttype" },
    [
      _vm.Initialtitle
        ? _c("h3", [
            _c("img", {
              staticClass: "dashboard-icons",
              attrs: { src: "/static/images/icons/submission_icon_blue.svg" },
            }),
            _c("span", [_vm._v("Project Type")]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "widget-body" }, [
        _c("table", { staticClass: "bar-graph" }, [
          _c("tbody", [
            _c(
              "tr",
              _vm._l(_vm.data, function (item, index) {
                return _c(
                  "td",
                  { key: index, staticClass: "bar-wrapper" },
                  [
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(item.value)),
                    ]),
                    _c(
                      "base-tooltip",
                      { attrs: { content: item.label, placement: "top" } },
                      [
                        _c("div", {
                          staticClass: "bar",
                          style: { height: item.height },
                        }),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "tr",
              { staticClass: "labels" },
              _vm._l(_vm.data, function (item, index) {
                return _c("td", { key: index }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        item.label.length > 4
                          ? `${item.label.slice(0, 3)}...`
                          : item.label
                      ) +
                      " "
                  ),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }